import { Select } from 'antd';
import styled from 'styled-components';

import useTranslation from 'customHooks/translate';
import { characterGroups } from 'consts';

interface OptionsProps {
  value: string;
  lable: string;
}

interface IProps {
  title: string;
  options: OptionsProps[];
  onChange: (value: unknown) => void;
}

export const ReportsSelect = ({ title, options, onChange }: IProps) => {
  const translation = useTranslation();

  const filterOption = (input: string, option: any) => {
    if (!input) return true;

    const charToGroupMap: { [key: string]: number } = {};
    characterGroups.forEach((group, index) => {
      group.forEach((char) => {
        charToGroupMap[char] = index;
      });
    });

    const inputLower = input.toLowerCase();
    const optionText = (option?.label || option?.lable || '').toLowerCase();

    if (optionText.includes(inputLower)) {
      return true;
    }

    let searchIdx = 0;
    let textIdx = 0;

    while (searchIdx < inputLower.length && textIdx < optionText.length) {
      const searchChar = inputLower[searchIdx];
      const textChar = optionText[textIdx];

      if (searchChar === textChar) {
        searchIdx++;
        textIdx++;
        continue;
      }

      const searchGroupIdx = charToGroupMap[searchChar];
      const textGroupIdx = charToGroupMap[textChar];

      if (
        searchGroupIdx !== undefined &&
        textGroupIdx !== undefined &&
        searchGroupIdx === textGroupIdx
      ) {
        searchIdx++;
        textIdx++;
        continue;
      }
      textIdx++;
    }

    return searchIdx === inputLower.length;
  };

  return (
    <div className="flex flex-col gap-[12px]">
      <p className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
        {title}
      </p>
      <StyledSelect
        dropdownStyle={{ zIndex: 2000 }}
        size="small"
        className="w-full rounded-[6px]"
        onChange={onChange}
        options={options}
        placeholder={translation.reports.PleaseChooseOption}
        showSearch
        filterOption={filterOption}
      />
    </div>
  );
};

const StyledSelect = styled(Select)`
  .ant-select-selection-search {
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-search-input {
    display: flex !important;
    align-items: center !important;
    line-height: 1.5 !important;
  }
`;
